export const COUNTRIES = [
    {
        value: 'IN',
        viewValue: 'India - IN',
    },
    {
        value: 'OM',
        viewValue: 'Oman - OM',
    },
    {
        value: 'AE',
        viewValue: 'UAE - AE',
    },
    {
        value: 'KW',
        viewValue: 'Kuwait - KW',
    },
    {
        value: 'BH',
        viewValue: 'Bahrain - BH',
    },
    {
        value: 'QA',
        viewValue: 'Qatar - QA',
    },
    {
        value: 'SA',
        viewValue: 'Saudi Arabia - SA',
    },
    {
        value: 'US',
        viewValue: 'United States of America - US',
    },
    {
        value: 'SG',
        viewValue: 'Singapore - SG',
    },
    {
        value: 'MY',
        viewValue: 'Malaysia - MY',
    },
    {
        value: 'UG',
        viewValue: 'Uganda - UG',
    },
    {
        value: 'TZ',
        viewValue: 'Tanzania - TZ',
    },
    {
        value: 'NG',
        viewValue: 'Nigeria - NG',
    },
];
